import styled from 'styled-components';
import { colors, fonts, pxToCssFont, breakpoints, pxToCssFontSize } from '@vfit/shared/themes';

export const ExternalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 0 32px;
  }
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: flex-start;
  margin-top: 32px;
`;
export const ActionContainer = styled.div`
  width: 100%;
`;
export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 20px;
  border: 1px solid #ccc;
`;
export const TopLayout = styled.div`
  display: flex;
  z-index: 1;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
  position: relative;
  border-radius: 20px 20px 0 0;
  padding: 24px 24px 16px 24px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 24px 24px 12px 24px;
  }
`;
export const OfferSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  .productDescription {
    margin: 0;
    color: ${colors.$0d0d0d};
    p {
      margin: 0 !important;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    .productDescription div {
      ${pxToCssFontSize(14)}
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    .productDescription div {
      ${pxToCssFontSize(14)}
    }
  }
`;
export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px 24px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 0 0 20px 20px;
`;
export const TagContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Tag = styled.div<{
  bgColor?: string;
  color?: string;
}>`
  ${({ bgColor }) => `background: ${bgColor || colors.$ffffff}`};
  ${({ color }) => `color: ${color || colors.$0d0d0d}`};
  border-radius: 20px;
  padding: 4px 10px;
  span {
    font-family: ${fonts.vodafone};
    font-weight: 700;
    ${pxToCssFont(12, 16)}
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
`;

export const CtaContainer = styled.div``;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 4px;
`;

export const Title = styled.div`
  font-family: ${fonts.vodafone};
  font-style: normal;
  font-weight: 800;
  ${pxToCssFont(24, 28)}
  color: ${colors.$ffffff}
`;

export const SubtitleCta = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(16, 22)}
  font-style: normal;
  font-weight: 700;
  color: ${colors.$ffffff};
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const DivImgContainer = styled.div`
  height: 100%;
  width: 100%;
  min-height: 100%;
  min-width: 100%;
  overflow: hidden;
  z-index: -1;
  object-fit: cover;
  object-position: center;
  border-radius: 15px 15px 0 0;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ModalTitle = styled.div`
  div {
    margin: 0;
    margin-bottom: 24px;
  }
`;

export const ModalContent = styled.div`
  div {
    margin: 0;
  }
`;

export const GoBackLabel = styled.div`
  color: ${colors.$262626};
  font-family: ${fonts.vodafone};
  font-style: normal;
  font-weight: 400;
  ${pxToCssFont(16, 22)};
`;
